import { render } from "./Bike.vue?vue&type=template&id=60dada77&ts=true"
import script from "./Bike.vue?vue&type=script&lang=ts"
export * from "./Bike.vue?vue&type=script&lang=ts"

import "./Bike.vue?vue&type=style&index=0&id=60dada77&lang=scss"

import exportComponent from "/home/newbuyanyinsuran/public_html/wizards/car.buyanyinsurance.ae/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__